// @flow

export const href = (): string => window.location.href;

export const hostname = (): string => window.location.hostname;
